export default "__VITE_ASSET__DlED7wCz__"